import NotificationManagementBaseController from '../common/notification_management.base.controller';

class NotificationManagementAllController extends NotificationManagementBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, $stateParams, $location) {
        super();
        // super(Auth, $state, User, NotificationManagementService, Modal, $translate, $stateParams, $location)
        this.hasAcl = {};
        this.$stateParams = $stateParams;
        this.User = User;
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() {
        let pageId = this.$stateParams.page
        if (pageId > 0) {
            this.page = pageId;
        }
    }

    edit(notification_management) {
        this.$state.go('notification_management.edit', ({
            id: notification_management.id
        }))
    }

    refresh() {
        this.loadData()
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page);
        this.$stateParams.page = this.page;
        this.$location.path(newUrl);
        this.loadData();
    }

    search() {
        this.page = 1;
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page);
        this.$stateParams.page = this.page;
        this.$location.path(newUrl);
        this.loadData();
    }

    loadData() { }

}

export default NotificationManagementAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/all/notification_management.all.controller.js